import React, { Component } from 'react'
import nopgimg from '../assets/404.png'
import { Redirect } from "react-router-dom";
class Nopgcomp extends Component {

    constructor() {
        super();
        this.state = { time: {}, seconds: 10 };
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }

    state = {
        redirect: false
    }

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    componentDidMount() {
        this.id = setTimeout(() => this.setState({ redirect: true }), 10000)
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
        this.startTimer()
    }

    startTimer() {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {

        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });


        if (seconds == 0) {
            clearInterval(this.timer);
        }
    }


    componentWillUnmount() {
        clearTimeout(this.id)
    }
    render() {

        return this.state.redirect ? <Redirect to="/" /> : (
            <div className="NoPageSection">
                <div className="logoNoPages">
                    <h1>Welp! That wasn't right :/</h1>
                    <h4>This page seems to be unreachable</h4>
                    <img src={nopgimg} />
                    <h4>Try refreshing the page or trying again at a later time</h4>
                    <p>Sorry for the inconvenience</p>
                    <p>Redirecting in {this.state.time.s} sec</p>

                </div>


            </div>
        )
    }

}

export default Nopgcomp;